<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="orderNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item dataField="orderNumber" [label]="{ text: 'Sales Order #' }"></dxi-item>
                    <!-- <dxi-item dataField="vendor"></dxi-item> -->
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-start mt-3">
                <button type="button" accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button type="button" (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="parts">
        <dx-data-grid
            #dataGrid
            [dataSource]="parts"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="salesOrder" caption="SalesOrder #" width="100" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="lineNumber" caption="Line #" width="55"></dxi-column>
            <dxi-column dataField="salesPart" caption="Ordered Part" width="200"></dxi-column>
            <dxi-column dataField="companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="quantity" caption="Qty" width="100"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" width="200"></dxi-column>
            <dxi-column dataField="description" caption="Description" width="200"></dxi-column>
            <dxi-column dataField="mfgPartNumber" caption="MfgPart #" width="200"></dxi-column>
            <dxi-column dataField="created" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="deleted" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="partLinkId" caption="PartLinkId" width="100"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="open(cell.data.orderId)">{{ cell.value || '(blank)' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="parts" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
